module.exports = __webpack_public_path__ + "img/zj4361_center_001.9f19d78d.png";